
import O1HD, { managers, modules, services } from "../../../../../../engines/gameEngine";
import utilsView from "../../../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../../../engines/modules/uiModule";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../../BundleResourceConfig";
import { PAGE } from "../../common/Enum";
import { ITerrorPagePrams } from "../../common/Interface";
import NormalLevelBase from "../../common/LevelBase";
import view_012 from "./view_012";

const { ccclass, property } = cc._decorator;

@ccclass
export default class lv10012 extends NormalLevelBase {

    /** 场景节点 */
    @property({ type: [cc.Node], displayName: "场景节点" })
    sceneNode: cc.Node[] = [];
    /** 防点击节点 */
    @property({ type: cc.Node, displayName: "防点击节点" })
    blockNode: cc.Node = null;

    /** 当前场景标签 */
    curSceneTag: number = 0;
    // LIFE-CYCLE CALLBACKS:

    onLoad() {
        services().miniGameSrv.getAppApiInstance().gameRecordStop();
        super.onLoad();
    }

    start() {
        super.start();
        this.init();
    }

    init(): void {
        // 打开微恐提示
        let self = this;
        const params: ITerrorPagePrams = {
            mode: this.m_mode,
            canCall: (() => {
                self.blockNode.active = false;
                // 
                services()
                    .miniGameSrv.getAppApiInstance()
                    .gameRecordStart({ duration: 180 });
                self.reNewScene();
            }),
            not: ()=> {
                this.destroyNode();
            },
        }
        this.scheduleOnce(() => {
            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.thruTimeAccess);
            modules().uiControlModule.OpenPage(PAGE.TERRORPAGE, UI_Z_INDEX.DIALOG, params, bundle, true);

        }, 0.3);
    }

    openBlock() {
        this.blockNode.active = true;
    }

    closeBlock() {
        this.blockNode.active = false;
    }

    /** 切换场景 -- 只要调用 就代表要切换下一个场景了 */
    switchScene() {
        // 先唤起黑幕，之后再切换场景
        this.curSceneTag++;
        this.reNewScene();
    }

    /** 更新场景 */
    reNewScene() {
        for (let i = 0; i < this.sceneNode.length; i++) {
            if (i == this.curSceneTag) {
                this.sceneNode[i].active = true; 
                this.sceneNode[i].getComponent(view_012).initLevel(this.csvInfo.level_bundle);
                continue;
            }
            this.sceneNode[i].active = false;
        }
    }

    titleStringList: string[] = ['', '', ''];

    reNewTiTles(tag: number): void {
        let title = this.node.getChildByName("title");
        for (let i = 0; i < title.childrenCount; i++) {
            if (i == tag) {
                title.children[tag].active = true;
            }
            else {
                title.children[i].active = false;
            }
        }
    }

    reNewTiTles2(tag: number): void {
        let title = this.node.getChildByName("title2");
        for (let i = 0; i < title.childrenCount; i++) {
            if (i == tag) {
                title.children[tag].active = true;
            }
            else {
                title.children[i].active = false;
            }
        }
    }
}
